export default "__VITE_ASSET__XNuBpJQr__"